var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatblack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    x: 3,
    y: 3,
    width: 18,
    height: 18,
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.0004 3h18v18h-18v-18z",
    clipRule: "evenodd",
    fill: "#fff",
    fillRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipRule: "evenodd",
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12 4.9996c-3.86 0-7 3.079-7 6.865 0 0.867 0.161 1.704 0.479 2.487 0.227 0.577 0.539 1.121 0.933 1.626 0.271 0.35 0.329 0.815 0.152 1.217l-0.733 1.676 3.247-0.56c0.226-0.042 0.47-0.025 0.702 0.05 0.71803 0.233 1.464 0.35 2.22 0.35 3.859 0 7-3.079 7-6.864 0-3.775-3.141-6.847-7-6.847zm-6.735 16h-0.086c-0.557 0-0.981-0.191-1.286-0.539-0.369-0.42-0.468-1.04-0.249-1.579l0.902-2.065c-0.378-0.545-0.689-1.123-0.924-1.724-0.411-1.012-0.622-2.101-0.622-3.228 0-4.888 4.037-8.865 9-8.865 4.962 0 9 3.969 9 8.847 0 4.888-4.038 8.864-9 8.864-0.923 0-1.833-0.136-2.708-0.407z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15 13c-0.552 0-1-0.447-1-1s0.448-1 1-1 1 0.447 1 1-0.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 13c-0.552 0-1-0.447-1-1s0.448-1 1-1 1 0.447 1 1-0.448 1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9 13c-0.552 0-1-0.447-1-1s0.448-1 1-1 1 0.447 1 1-0.448 1-1 1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatblack);
export default __webpack_public_path__ + "static/media/chatblack.601a0e18d59fd71eca1106941f221aef.svg";
export { ForwardRef as ReactComponent };